import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ClientLayout from "../components/layout/ClientLayout";
import axiosInstance from "../../../utils/axiosInstance";
import { useNavigate, Link } from "react-router-dom";

const CurrentPosition = () => {
  const [cricketList, setCricketList] = useState([]);
  const [tennisList, setTennisList] = useState([]);
  const [footballList, setFootballList] = useState([]);
  const [hourseList, setHourseList] = useState([]);
  const [grayHoundList, setGrayHoundList] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data } = await axiosInstance.get("/current-position");
        let recordList = data.recordList;
        let cricketRecord = [];
        let tennisRecord = [];
        let footballRecord = [];
        let hourseRaceRecord = [];
        let grayHoundRecord = [];

        for (let i = 0; i < recordList.length; i++) {
          let obj = recordList[i];
          if (obj.game_type === 1) {
            console.error("obj->", obj);
            if (obj.market_type == "betfairfancy") {
              obj.cat_mid = obj.parent_catmid;
            }
            if (obj.market_type == "evenodd") {
              obj.cat_mid = obj.parent_catmid;
            }
            if (obj.market_type == "f") {
              obj.cat_mid = obj.parent_catmid;
            }

            if (obj.market_type == "tie") {
              obj.cat_mid = obj.parent_catmid;
              obj.event_name = obj.event_name + "/TIE";
            }

            if (obj.market_type == "bm") {
              obj.cat_mid = obj.parent_catmid;
              obj.event_name = obj.event_name + "/Bookmaker";
            }

            cricketRecord.push(obj);
          }
          if (obj.game_type === 2) {
            if (obj.market_type == "ff") {
              obj.event_name = obj.event_name + "/" + obj.runnername;
              obj.cat_mid = obj.parent_catmid;
            }
            footballRecord.push(obj);
          }

          if (obj.game_type === 3) {
            tennisRecord.push(obj);
          }

          if (obj.game_type === 4) {
            hourseRaceRecord.push(obj);
          }

          if (obj.game_type === 5) {
            grayHoundRecord.push(obj);
          }
        }
        setCricketList(cricketRecord);
        setFootballList(footballRecord);
        setTennisList(tennisRecord);
        setHourseList(hourseRaceRecord);
        setGrayHoundList(grayHoundRecord);
      } catch (error) {
        console.error("Failed to load profile data:", error);
      }
    };

    fetchProfile();
  }, []);

  /*
  useEffect(() => {
    const fetchProfile = async () => {

      const { data } = await axiosInstance.get("/betfair-baccarat/betlist");
      console.log("Betlist API Response:", data);

      try {
        const { data } = await axiosInstance.get("/betfair-baccarat/betlist");

        console.log(data);

        setCricketList(data.data); // ya data.recordList, response ke hisaab se
      } catch (error) {
        console.log(error);
      }
    };

    fetchProfile();
  }, []);*/

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <ClientLayout>
      <div classNameName="container-fluid">
        <div className="row" style={{ marginTop: "0%", marginBottom: "3%" }}>
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="content-wrap body">
                <div className="table-wrap">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header">
                          <i className="fa fa-align-justify"></i>
                          Market Position
                        </div>
                        <div className="card-body" style={{ padding: "10px" }}>
                          <div style={{ margin: "0px" }}>
                            <table
                              style={{ width: "100%" }}
                              className="table table-bordered table-striped table-sm"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      padding: "7px",
                                      width: "75%"
                                    }}
                                  >
                                    Cricket
                                  </td>

                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      padding: "7px"
                                    }}
                                  >
                                    Amount
                                  </td>
                                </tr>
                              </tbody>
                              <tbody id="cricketTblList">
                                {cricketList.map((item, idx) => (
                                  <tr style={{ background: "white" }}>
                                    <td style={{ padding: "7px" }}>
                                      <Link
                                        style={{
                                          color: "#00b181",
                                          fontSize: "18px"
                                        }}
                                        to={`/market/${item.cat_mid}`}
                                      >
                                        {item.event_name}
                                      </Link>
                                    </td>
                                    <td style={{ padding: "7px" }}>
                                      <span style={{ color: "red" }}>
                                        {formatTruncate(
                                          Math.round(item.sharing_exp_amount)
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <table
                              style={{ width: "100%" }}
                              className="table table-bordered table-striped table-sm"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      padding: "7px",
                                      width: "75%"
                                    }}
                                  >
                                    Soccer
                                  </td>

                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      padding: "7px"
                                    }}
                                  >
                                    Amount
                                  </td>
                                </tr>
                              </tbody>
                              <tbody>
                                {footballList.map((item, idx) => (
                                  <tr style={{ background: "white" }}>
                                    <td style={{ padding: "7px" }}>
                                      <Link
                                        style={{
                                          color: "#00b181",
                                          fontSize: "18px"
                                        }}
                                        to={`/market/${item.cat_mid}`}
                                      >
                                        {item.event_name}{" "}
                                      </Link>
                                    </td>
                                    <td style={{ padding: "7px" }}>
                                      <span style={{ color: "red" }}>
                                        {formatTruncate(
                                          Math.round(item.sharing_exp_amount)
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <table
                              style={{ width: "100%" }}
                              className="table table-bordered table-striped table-sm"
                              id="tblTennis"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      padding: "7px",
                                      width: "75%"
                                    }}
                                  >
                                    Tennis
                                  </td>

                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      padding: "7px"
                                    }}
                                  >
                                    Amount
                                  </td>
                                </tr>
                              </tbody>
                              <tbody>
                                {tennisList.map((item, idx) => (
                                  <tr style={{ background: "white" }}>
                                    <td style={{ padding: "7px" }}>
                                      <Link
                                        style={{
                                          color: "#00b181",
                                          fontSize: "18px"
                                        }}
                                        to={`/market/${item.cat_mid}`}
                                      >
                                        {item.event_name}/{item.runnername}/
                                        {item.market_type}
                                      </Link>
                                    </td>
                                    <td style={{ padding: "7px" }}>
                                      <span style={{ color: "red" }}>
                                        {formatTruncate(
                                          Math.round(item.sharing_exp_amount)
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <table
                              style={{ width: "100%" }}
                              className="table table-bordered table-striped table-sm"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      padding: "7px",
                                      width: "75%"
                                    }}
                                  >
                                    Horse Race
                                  </td>

                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      padding: "7px"
                                    }}
                                  >
                                    Amount
                                  </td>
                                </tr>
                              </tbody>
                              <tbody>
                                {hourseList.map((item, idx) => (
                                  <tr style={{ background: "white" }}>
                                    <td style={{ padding: "7px" }}>
                                      <Link
                                        style={{
                                          color: "#00b181",
                                          fontSize: "18px"
                                        }}
                                        to={`/market/${item.cat_mid}`}
                                      >
                                        {item.event_name}/{item.runnername}/
                                        {item.market_type}
                                      </Link>
                                    </td>
                                    <td style={{ padding: "7px" }}>
                                      <span style={{ color: "red" }}>
                                        {formatTruncate(
                                          Math.round(item.sharing_exp_amount)
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <table
                              style={{ width: "100%" }}
                              className="table table-bordered table-striped table-sm"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      padding: "7px",
                                      width: "75%"
                                    }}
                                  >
                                    Grey Hound
                                  </td>

                                  <td
                                    style={{
                                      border: "1px solid #c8ced3",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      padding: "7px"
                                    }}
                                  >
                                    Amount
                                  </td>
                                </tr>
                              </tbody>
                              <tbody>
                                {grayHoundList.map((item, idx) => (
                                  <tr style={{ background: "white" }}>
                                    <td style={{ padding: "7px" }}>
                                      <Link
                                        style={{
                                          color: "#00b181",
                                          fontSize: "18px"
                                        }}
                                        to={`/market/${item.cat_mid}`}
                                      >
                                        {item.event_name}/{item.runnername}/
                                        {item.market_type}
                                      </Link>
                                    </td>
                                    <td style={{ padding: "7px" }}>
                                      <span style={{ color: "red" }}>
                                        {formatTruncate(
                                          Math.round(item.sharing_exp_amount)
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default CurrentPosition;
